<script setup>
import { computed, onMounted } from "vue";
import { RouterView, useRoute } from "vue-router";
import AppNavbar from "@/components/layout/AppNavbar.vue";
import AppFooter from "@/components/layout/AppFooter.vue";
import { upsertJsonLd } from "@/composables/useJsonLd";
import { buildOrganization, buildWebSite } from "@/seo/structuredData";

const route = useRoute();
const usesStandaloneLayout = computed(() =>
  route.name === "Home" || route.name === "HomeV2Preview"
);
const usesHomeV2Header = computed(() =>
  usesStandaloneLayout.value || route.name === "catalogo" || route.name === "recomendaciones"
);

// Datos estructurados que aplican a todo el sitio (no cambian por ruta),
// por eso se inyectan una sola vez aquí en lugar de por vista.

const isTracking = computed(() => route.name === "tracking");

// Datos estructurados que aplican a todo el sitio
onMounted(() => {
  upsertJsonLd("ld-organization", buildOrganization());
  upsertJsonLd("ld-website", buildWebSite());
});
</script>

<template>
  <v-app class="background">
    <AppNavbar v-if="!usesHomeV2Header" />

    <AppNavbar v-if="!isTracking" />

    <v-main>
      <RouterView />
    </v-main>

    <AppFooter v-if="!usesStandaloneLayout" />
    <AppFooter v-if="!isTracking" />

  </v-app>
</template>